import { migrateAllFinancialStatuses, migrateFinancialStatuses } from '../services/receiptService';

(window as any).migrateAllFinancialStatuses = async () => {
  console.log('🔄 Running global financial status migration for all organizations...');
  const result = await migrateAllFinancialStatuses();
  console.log('✅ Migration complete:', result);
  return result;
};

(window as any).migrateFinancialStatuses = async (organizationId?: string) => {
  if (!organizationId) {
    console.log('Usage: migrateFinancialStatuses("organizationId")');
    console.log('Or use migrateAllFinancialStatuses() for all organizations');
    return;
  }
  console.log(`🔄 Running financial status migration for org: ${organizationId}`);
  const result = await migrateFinancialStatuses(organizationId);
  console.log('✅ Migration complete:', result);
  return result;
};
